import React from 'react';
import Gr8 from '@/pages/gr8-sports/gr8';

const SportsContainer = () => {
  return <Gr8 />;
};

export default SportsContainer;
